module.exports = __webpack_public_path__ + "img/lens-160-plus-02.e53a17f1.png";